import { render, staticRenderFns } from "./HrgaReportTab.vue?vue&type=template&id=371b8c55"
import script from "./HrgaReportTab.vue?vue&type=script&lang=js"
export * from "./HrgaReportTab.vue?vue&type=script&lang=js"
import style0 from "./HrgaReportTab.vue?vue&type=style&index=0&id=371b8c55&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports